/* Doggy Needs dn8: shoppable hotspots, scroll reveal, parallax, wipe, drag carousels. No dependencies, ~4 KB. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) doc.classList.add('dn8-motion');

  /* Hotspots: hover/focus opens on desktop (CSS); tap toggles everywhere. */
  function closeAll(except) {
    document.querySelectorAll('.dn8-hs.is-open').forEach(function (h) {
      if (h === except) return;
      h.classList.remove('is-open');
      var b = h.querySelector('.dn8-hs__dot'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.dn8-hs__dot');
    if (dot) {
      e.preventDefault();
      var hs = dot.closest('.dn8-hs');
      var open = !hs.classList.contains('is-open');
      closeAll(hs);
      hs.classList.toggle('is-open', open);
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!(e.target.closest && e.target.closest('.dn8-hs__card'))) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Reveal + wipe */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-dn8-reveal]:not(.is-in),[data-dn8-wipe]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    /* A wiped element is fully clipped, so Chromium never reports it intersecting: observe its parent instead. */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target._dn8Wipe || en.target;
        t.classList.add('is-in'); io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    els.forEach(function (el) {
      if (el.hasAttribute('data-dn8-wipe') && el.parentElement) { el.parentElement._dn8Wipe = el; io.observe(el.parentElement); }
      else io.observe(el);
    });
  }

  /* Parallax: big photos drift a few percent while in view */
  var px = [];
  function initParallax() {
    px = Array.prototype.slice.call(document.querySelectorAll('[data-dn8-parallax]'));
    if (reduce || !px.length) return;
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); /* -1..1 */
        var amt = parseFloat(el.getAttribute('data-dn8-parallax')) || 6;
        var t = el.querySelector('.dn8-px');
        if (t) t.style.transform = 'translate3d(0,' + (p * -amt).toFixed(2) + '%,0) scale(1.12)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  /* Drag-to-scroll rails (mouse); touch uses native swipe */
  function initRails(root) {
    (root || document).querySelectorAll('[data-dn8-drag]').forEach(function (rail) {
      if (rail.dataset.dn8Ready) return; rail.dataset.dn8Ready = '1';
      var down = false, sx = 0, sl = 0, moved = false;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; rail.classList.add('is-drag');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; rail.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () { if (down) { down = false; rail.classList.remove('is-drag'); } });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var wrap = rail.closest('[data-dn8-rail-wrap]');
      if (wrap) wrap.querySelectorAll('[data-dn8-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = rail.firstElementChild; var step = card ? card.getBoundingClientRect().width + 20 : 320;
          rail.scrollBy({ left: step * (+b.getAttribute('data-dn8-step')), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function boot(root) { initReveal(root); initRails(root); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.DN8 = { boot: boot };
})();
